import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { environment } from '../../../environments/environment';
import { Wcb } from '../../onboarding/classes/wcb';


@Injectable()
export class WcbService {

  constructor(private http: Http) { }

  getWcb(orgId: number) {
    let headers = new Headers({ 'Authorization': `Bearer ${localStorage.onboardingToken}` })
    let options = new RequestOptions({ headers: headers });
    return this.http.get(`${environment.organizationsUrl}${orgId}/${environment.wcbUrl}`, options)
      .map(res => res.json())
  }

  addWcb(orgId: number, info: Wcb) {
    let data = { wcb_detail: info, commit: 'Add', organization_id: orgId };
    let headers = new Headers({ 'Authorization': `Bearer ${localStorage.onboardingToken}` })
    let options = new RequestOptions({ headers: headers });
    return this.http.post(`${environment.organizationsUrl}${orgId}/${environment.wcbUrl}`, data, options)
      .map(res => res.json())
  }

  editWcb(orgId: number, id: number, info: Wcb) {
    let data = { wcb_detail: info, commit: 'Add', organization_id: orgId, id };
    let headers = new Headers({ 'Authorization': `Bearer ${localStorage.onboardingToken}` })
    let options = new RequestOptions({ headers: headers });
    return this.http.patch(`${environment.organizationsUrl}${orgId}/organization_setups/wcb_details/${id}.json`, data, options)
      .map(res => res.json())
  }

  deleteWcb(orgId: number, id: number) {
    let headers = new Headers({ 'Authorization': `Bearer ${localStorage.onboardingToken}` })
    let options = new RequestOptions({ headers: headers });
    return this.http.delete(`${environment.organizationsUrl}${orgId}/organization_setups/wcb_details/${id}.json`, options)
      .map(res => res.json())
  }
}



// WEBPACK FOOTER //
// ./src/app/onboarding/services/wcb.service.ts